<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Submerchant</h5>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Parent Merchant Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-select
                                    label-placeholder="Parent Merchant Name"
                                    placeholder="Select Merchant Name"
                                    name="parent merchant name"
                                    v-validate="'required'"
                                    class="w-full mb-4 no-icon-border"
                                    v-model="merchantInfo.parent" :disabled="validateMerchantRole">
                                <vs-select-item
                                        :key="index"
                                        :value="item"
                                        :text="item.full_name"
                                        v-for="(item,index) in merchants"/>
                            </vs-select>
                            <span class="text-danger text-sm" v-show="errors.has('parentId')">{{ errors.first('parent merchant name') }}</span>

                        </div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">
                            Submerchant Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Submerchant Name"
                                    v-model="merchantInfo.name"
                                    class="w-full mb-4 no-icon-border"
                                    name="submerchant name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('submerchant name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">
                            Business Entity ID
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                type="text"
                                placeholder="Business Entity ID"
                                v-model="merchantInfo.business_entity_id"
                                class="w-full mb-4 no-icon-border"
                                name="business_entity_id"
                            />
                            <span class="text-danger text-sm"></span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Address
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Address"
                                    v-model="merchantInfo.address"
                                    class="w-full mb-4 no-icon-border"
                                    name="address"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('address') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Email Address
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Emaill Address"
                                    v-model="merchantInfo.email"
                                    class="w-full mb-4 no-icon-border"
                                    name="email address"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('email address') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Phone Number
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    v-validate="'required|numeric|min:6|max:13'"
                                    name="phone number"
                                    placeholder="Phone Number"
                                    v-model="merchantInfo.phoneNumber"
                                    class="w-full mb-4 no-icon-border"/>
                            <span class="text-danger text-sm">{{ errors.first('phone number') }}</span>
                        </div>
                    </div>

                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Merchant has consolidation file?
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <ul class="demo-alignment">
                                <li>
                                    <vs-radio id="rdo-has-fk-yes" v-model="merchantHasFk" vs-value="yesfk" >yes</vs-radio>
                                </li>
                                <li>
                                    <vs-radio id="rdo-has-fk-no" v-model="merchantHasFk" vs-value="nofk" >no</vs-radio>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                        <div class="table-cell w-2/5 p-4">
                            Max time sending consolidation file
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <flat-pickr :config="configConsolidationProcessTime" v-model="consolidationProcessTime" placeholder="Max time"/>
                        </div>
                    </div>

                    <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                        <div class="table-cell w-2/5 p-4">
                            Consolidation emails notification
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="flex flex-no-wrap">
                                <vs-input 
                                    type="text" 
                                    v-model="consolidationEmailTemp" 
                                    placeholder="Email notification" 
                                    class="w-full mb-4 no-icon-border"
                                    maxLength=50 
                                />
                                <vs-button
                                    id="btn-add-consolidation-email"
                                    style="margin-left: 5px;"
                                    class="w-1/5 mb-4"
                                    icon-pack="feather"
                                    icon="icon-plus"
                                    @click="addConsolidationEmail"
                                ></vs-button>
                            </div>
                        </div>
                    </div>

                    <div class="table-row w-full" v-if="showMerchantConsolidationConfigs === true && merchantConsolidationEmails.length > 0">
                        <div class="table-cell w-2/5 px-3">
                            &nbsp;
                        </div>
                        <div class="table-cell w-3/5 px-3">
                            <div class="px-4 py-2"><h5 style="font-weight:700;color:#636363;">Email added</h5></div>
                            <div class="w-full flex flex-wrap" :key="ind" v-for="(data, ind) in merchantConsolidationEmails">
                                <div class="w-full px-2 py-2 flex flex-wrap">
                                    <div class="w-4/5 px-3 py-2" style="word-break: break-word;">{{data}}</div>
                                    <div class="w-1/5 py-2" style="text-align: center;">
                                        <feather-icon
                                            icon="Trash2Icon"
                                            svgClasses="h-5 w-5"
                                            class="cursor-hand"
                                            @click="deleteConsolidationEmail(ind)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
                </div>
            </div>
            <div class="w-1/2 text-right">
                <span class="text-danger">* required field</span>
            </div>
        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button type="border" @click="cancelAction">Cancel</vs-button>
                <vs-button class="ml-4" @click="submitRequest">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import MerchantAPI from "@/network/api/MerchantAPI"
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
          flatPickr,
        },
        data() {
            return {
                merchantInfo: {
                    id: '',
                    name: "",
                    email: "",
                    address: "",
                    password: "",
                    confirmPassword: "",
                    phoneNumber: "",
                    parent: "",
                    business_entity_id: "",
                    config: {},
                },
                merchants: [],
                merchantHasFk: "",
                showMerchantConsolidationConfigs: false,
                configConsolidationProcessTime: {
                    noCalendar: true,
                    enableTime: true,
                    enableSeconds: true,
                    dateFormat: 'H:i:S',
                    time_24hr: true,
                },
                consolidationProcessTime: null,
                consolidationEmailTemp: "",
                merchantConsolidationEmails: [],
                merchantData: null,
            }
        },
        computed: {
            validateForm() {
                return (
                    !this.errors.any() &&
                    this.merchantInfo.name != "" &&
                    this.merchantInfo.email != "" &&
                    this.merchantInfo.address != "" &&
                    this.merchantInfo.parent !== ""
                );
            }
        },
        methods: {
            openLoading() {
              this.$vs.loading({
                  type: "default"
              });
            },
            cancelAction() {
                this.$router.push({name: 'merchantManagement'});
            },
            validateMerchantRole() {
                const role = localStorage.getItem("userRole")
                return role == 'merchant_admin'
            },
            submitRequest() {
                if (!this.validateForm) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input all required fields!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                }

                if (this.merchantHasFk === "yesfk" && this.consolidationProcessTime === null) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input consolidation process time field!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                }

                if (this.merchantHasFk === "yesfk" && this.merchantConsolidationEmails.length <= 0) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input consolidation emails field!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                }

                let config = {}
                config = this.merchantInfo.config
                config.merchant_has_fk  = (this.merchantHasFk === "yesfk") ? true : false
                config.consolidation_process_time = (this.merchantHasFk === "yesfk") ? this.consolidationProcessTime : ""
                config.merchant_consolidation_emails = (this.merchantHasFk === "yesfk") ? this.merchantConsolidationEmails : []

                let payload = {
                    id: this.merchantInfo.id,
                    merchantInfo: {
                        full_name: this.merchantInfo.name,
                        brand_name: '-',
                        category_id: this.merchantInfo.parent.category_id,
                        email: this.merchantInfo.email,
                        phone: this.merchantInfo.phoneNumber,
                        parent_id: this.merchantInfo.parent.id,
                        business_entity_id: this.merchantInfo.business_entity_id,
                        details: {
                            address: this.merchantInfo.address,
                        },
                        config: config,
                        user_action: JSON.parse(localStorage.getItem('userInfo')).displayName
                    },
                    notify: this.$vs.notify
                }

                this.openLoading()
                MerchantAPI.Update(payload).then((result) => {
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Merchant Management",
                        activity: "Edit Submerchant",
                        data_before: this.merchantData,
                        data_after: payload,
                    })
                    this.$vs.notify({
                        title: "Info",
                        text: result.message,
                        iconPack: "feather",
                        icon: "icon-check-square",
                        color: "success",
                        position: "top-right"
                    });

                    let id =this.$route.params.parent_id
                    this.$router.push({
                        name: "subMerchantList",
                        params: {
                            id: id
                        }
                    })
                })
            },
            addConsolidationEmail() {
                if (this.consolidationEmailTemp.length === 0) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Consolidation email must be fill!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                let regexEmail = /\S+@\S+\.\S+/;
                if (!regexEmail.test(this.consolidationEmailTemp)) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Email format not valid!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                if (this.merchantConsolidationEmails.includes(this.consolidationEmailTemp)){
                    this.$vs.notify({
                        title: "Warning",
                        text: "Consolidation email already exist, please insert other email!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                if (this.merchantConsolidationEmails.length >= 5) {
                     this.$vs.notify({
                        title: "Warning",
                        text: "Max 5 consolidation emails!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                this.merchantConsolidationEmails.push(this.consolidationEmailTemp)
                this.consolidationEmailTemp = ""
            },
            deleteConsolidationEmail(index) {
                this.merchantConsolidationEmails.splice(index, 1)
            },
        },
        watch: {
            merchantHasFk: function(val) {
                if (val === "yesfk") {
                    this.showMerchantConsolidationConfigs = true
                } else {
                    this.showMerchantConsolidationConfigs = false
                }
            }
        },
        mounted() {
            if (!this.validateMerchantRole()) {
                MerchantAPI.ListMerchantOptions().then((result) => {
                    this.merchants = result.data
                })
            } else {
                let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant
                this.merchants = [merchant]
                this.merchantInfo.parent = merchant
            }

            MerchantAPI.MerchantDetail({id: this.$route.params.id, condition:true}).then((result) => {
                    if (result.data !== null) {
                        for (let merchant of result.data) {
                            this.merchantData = merchant
                            this.merchantInfo.id = merchant.id
                            this.merchantInfo.name = merchant.full_name
                            this.merchantInfo.email = merchant.email
                            this.merchantInfo.status = merchant.status
                            this.merchantInfo.phoneNumber = merchant.phone
                            this.merchantInfo.business_entity_id = merchant.business_entity_id
                            this.merchantInfo.config = merchant.config
                            if (merchant.details !== null) {
                                if (merchant.details.address !== undefined)
                                    this.merchantInfo.address = merchant.details.address
                            }

                            for (const parent of this.merchants){
                                if (merchant.parent.id === parent.id){
                                    this.merchantInfo.parent = parent
                                    break
                                }
                            }

                            if (merchant.config != null) {
                              if (merchant.config.hasOwnProperty('merchant_has_fk')) {
                                if (this.merchantInfo.config.merchant_has_fk === true) {
                                  this.merchantHasFk="yesfk"
                                  this.showMerchantConsolidationConfigs = true
                                } else {
                                  this.merchantHasFk = "nofk"
                                  this.showMerchantConsolidationConfigs = false
                                }
                              } else {
                                this.merchantHasFk = "nofk"
                                this.showMerchantConsolidationConfigs = false
                              }
                              if (merchant.config.hasOwnProperty('consolidation_process_time')) {
                                if (this.merchantInfo.config.consolidation_process_time !== "") {
                                  this.consolidationProcessTime = this.merchantInfo.config.consolidation_process_time
                                } else {
                                  this.consolidationProcessTime = null
                                }
                              } else {
                                this.consolidationProcessTime = null
                              }
                              if (merchant.config.hasOwnProperty('merchant_consolidation_emails')) {
                                if (typeof this.merchantInfo.config.merchant_consolidation_emails === "object") {
                                  this.merchantConsolidationEmails = this.merchantInfo.config.merchant_consolidation_emails
                                } else {
                                  this.merchantConsolidationEmails = []
                                }
                              } else {
                                this.merchantConsolidationEmails = []
                              }
                            } else {
                              this.merchantHasFk = "nofk"
                              this.consolidationProcessTime = null
                              this.merchantConsolidationEmails = []
                            }
                        }
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    .m-right-download {
        margin-right: -39px;
    }

    .flatpickr-input {
      padding: .7rem;
      font-size: 1rem;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: #626262;
      width: 100%;
    }
</style>